export const DAYS_OF_WEEK_DISPLAY = {
  [`["Mon","Tue","Wed","Thu","Fri"]`]: 'Mon - Fri',
  [`["Mon","Tue","Wed"]`]: 'Mon - Wed',
  [`["Mon","Tue","Wed","Thu"]`]: 'Mon - Thu',
  [`["Mon","Tue","Thu","Fri"]`]: 'Mon - Fri, no session Wed',
  [`["Mon"]`]: 'Mon',
  [`["Tue"]`]: 'Tue',
  [`["Wed"]`]: 'Wed',
  [`["Thu"]`]: 'Thu',
  [`["Fri"]`]: 'Fri',
  [`["Sat"]`]: 'Sat',
  [`["Sun"]`]: 'Sun',
}

export const ORG_NAMES = {
  burlingame: 'Burlingame',
  foster_city: 'Foster City',
  highlands_rec: 'Highlands Rec',
  pacifica: 'Pacifica',
  pjcc: 'PJCC',
  redwood_city: 'Redwood City',
  san_bruno: 'San Bruno',
  san_carlos: 'San Carlos',
  san_mateo: 'San Mateo'
}

export const ORG_CONTACTS = {
  burlingame: {
    name: '',
    email: '',
    phone: '',
  },
  foster_city: {
    name: '',
    email: '',
    phone: '',
  },
  pacifica: {
    name: '',
  },
  redwood_city: {
    name: '',
    email: '',
    phone: '',
  },
  san_bruno: {
    name: '',
  },
}

export const SEASONS = ['Spring', 'Summer', 'Fall', 'Winter']

export const PROGRAM_TYPES = ['camp', 'class']

export const PROGRAM_STATUSES = ['active', 'at-risk', 'canceled', 'complete', 'confirmed', 'invoiced', 'paid', 'registration']

export const SPORTS = [
  'baseball',
  'baseball-tots',
  'basketball',
  'basketball-tots',
  'flag-football',
  'golf',
  'lacrosse',
  'mini-hawk',
  'mini-multi-sport-stem',
  'multi-sport',
  'multi-sport-tots',
  'pickleball',
  'soccer',
  'soccer-tots',
  'tennis',
  'track-field',
  'ultimate-frisbee',
  'volleyball',
  'volleyball-tots'
]

export const CONFIGIO_CATEGORY_MAP = {
  baseball_camp: 'Baseball Camp',
  baseball_class: 'Baseball (Year-Round)',
  basketball_camp: 'Basketball Camp',
  basketball_class: 'Basketball (Year-Round)',
  cheerleading_camp: 'Cheerleading Camp',
  cheerleading_class: 'Cheerleading (Year-Round)',
  'flag-football_camp': 'Flag Football Camp',
  'flag-football_class': 'Flag Football (Year-Round)',
  golf_camp: 'Beginning Golf Camp',
  golf_class: 'Beginning Golf (Year-Round)',
  lacrosse_camp: 'Lacrosse Camp',
  lacrosse_class: 'Lacrosse (Year-Round)',
  'mini-hawk_camp': 'Mini-Hawk Camp',
  'mini-hawk_class': 'Mini-Hawk (Year-Round)',
  'multi-sport_camp': 'Multi-Sport Camp',
  'multi-sport_class': 'Multi-Sport (Year-Round)',
  'multi-sport-stem_class': 'STEM & Play: Multi-Sport (Year-Round)',
  pickleball_camp: 'Pickleball Camp',
  pickleball_class: 'Pickleball (Year-Round)',
  soccer_camp: 'Soccer Camp',
  soccer_class: 'Soccer (Year-Round)',
  tennis_camp: 'Tennis Camp',
  tennis_class: 'Tennis (Year-Round)',
  'track-field_camp': 'Track & Field Camp',
  'track-field_class': 'Track & Field (Year-Round)',
  'ultimate-frisbee_camp': 'Flag Football Camp',
  'ultimate-frisbee_class': 'Flag Football (Year-Round)',
  volleyball_camp: 'Volleyball Camp',
  volleyball_class: 'Volleyball (Year-Round)',
  'soccer-tots_class': 'SoccerTots',
  'basketball-tots_class': 'HoopsterTots',
  'baseball-tots_class': 'BaseballTots',
  'multi-sport-tots_class': 'Multi-SportTots',
  'flag-football-tots_class': '1stDownTots',
  'volleyball-tots_class': 'VolleyKats',
}